/**
 * Removes file extension from filename for display purposes
 * Only removes extension if media_format is APPLICATION
 * @param {string} filename - The full filename with extension
 * @param {string} mediaFormat - The media format of the file
 * @returns {string} - Filename without extension (only for APPLICATION files)
 */
export const removeFileExtension = (filename, mediaFormat) => {
    if (!filename || typeof filename !== 'string') {
        return filename;
    }

    // Only remove extension for APPLICATION files
    if (mediaFormat !== 'APPLICATION') {
        return filename;
    }

    const lastDotIndex = filename.lastIndexOf('.');

    // If no dot found or dot is at the beginning (hidden file), return original
    if (lastDotIndex === -1 || lastDotIndex === 0) {
        return filename;
    }

    // Return filename without extension
    return filename.substring(0, lastDotIndex);
};

/**
 * Gets only the file extension from filename
 * @param {string} filename - The full filename with extension
 * @returns {string} - File extension (including the dot)
 */
export const getFileExtension = (filename) => {
    if (!filename || typeof filename !== 'string') {
        return '';
    }

    const lastDotIndex = filename.lastIndexOf('.');

    // If no dot found or dot is at the beginning (hidden file), return empty string
    if (lastDotIndex === -1 || lastDotIndex === 0) {
        return '';
    }

    // Return extension (including the dot)
    return filename.substring(lastDotIndex);
};

/**
 * Splits filename into name and extension parts
 * @param {string} filename - The full filename with extension
 * @returns {object} - Object with fileName and extension properties
 */
export const splitFileNameAndExtension = (filename) => {
    if (!filename || typeof filename !== 'string') {
        return { fileName: filename, extension: '' };
    }

    const lastDotIndex = filename.lastIndexOf('.');

    // If no dot found or dot is at the beginning (hidden file)
    if (lastDotIndex === -1 || lastDotIndex === 0) {
        return { fileName: filename, extension: '' };
    }

    const fileName = filename.substring(0, lastDotIndex);
    const extension = filename.substring(lastDotIndex);

    return { fileName, extension };
}; 